import React, { useState, useEffect } from 'react';
import voca from 'voca';
import CustomLoader from '../common/CustomLoader';
import { loadOrganizationDetails } from '../home/app_util';
import Swal from 'sweetalert2';

const PublishProjectModal = ({
  project,
  projectId,
  popoverOpen,
  redirectUrl,
  token,
  toggle,
  generateProjectURL,
  selVersion,
  handleVersionChange,
  versions,
  publishApp,
  isPublishing,
  slug,
  version,
  actions,
  isReadOnly,
}) => {
  const [debugModeState, setDebugModeState] = useState({});
  const [cleanPublishState, setCleanPublishState] = useState({});

  let { domainName, url, environments, seoName, projectType, debugMode } = project;
  environments = environments ? environments.filter((env) => env.envType !== 'PREVIEW') : [];

  useEffect(() => {
    if (environments && debugMode && debugMode.length > 0) {
      const initialState = environments.reduce((acc, env) => {
        acc[env.envType] = {
          isEnable: debugMode.includes(env.envType),
          environment: env.envType,
        };
        return acc;
      }, {});
      setDebugModeState(initialState);
    }

    if (environments) {
      const cleanInit = environments.reduce((acc, env) => {
        acc[env.envType] = true;
        return acc;
      }, {});
      setCleanPublishState(cleanInit);
    }
  }, [debugMode]);

  let urlToOpen = !domainName || domainName === url ? '' : `https://${domainName}`;
  if (slug && urlToOpen) {
    urlToOpen += urlToOpen.endsWith('/') ? slug : `/${slug}`;
  }

  const handleDebugModeToggle = async (envType) => {
    const currentState = debugModeState[envType] ? debugModeState[envType].isEnable : false;
    const newState = !currentState;
    const heading = `Are you sure to ${
      newState ? 'enable' : 'disable'
    } debug mode for ${voca.titleCase(envType)}?`;
    const description = newState
      ? 'It will start displaying logs in the browser console window.'
      : 'It will stop displaying logs in the browser console window.';

    const result = await Swal.fire({
      title: heading,
      text: description,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: newState ? '#3085d6' : '#d33',
      cancelButtonColor: '#757f91',
      confirmButtonText: `Yes, ${newState ? 'enable' : 'disable'} it!`,
    });

    if (result.isConfirmed) {
      const newStateObject = {
        isEnable: newState,
        environment: envType,
      };

      setDebugModeState({
        ...debugModeState,
        [envType]: newStateObject,
      });
      await actions.toggleDebugMode({ projectId, version, data: newStateObject });
    }
  };

  const handleCleanToggle = (envType) => {
    setCleanPublishState({
      ...cleanPublishState,
      [envType]: !cleanPublishState[envType],
    });
  };

  const subscription = loadOrganizationDetails('subscription');
  let message = '';
  let disable = false;
  let link = '';
  let linkMsg = '';
  if (!subscription || subscription === 'BUILDER_FREE') {
    disable = true;
    message = 'Please upgrade your account to enable this feature.';
    link = `${process.env.REACT_APP_ORGANIZATION}accounts`;
    linkMsg = 'Upgrade';
  }
  console.log('projectType :>> ', projectType);
  if (projectType === 'FREE' && subscription !== 'UNLIMITED') {
    disable = true;
    message = "You don't have cloud/hosting subscription. Please subscribe to enable this feature.";
    link = `${process.env.REACT_APP_ORGANIZATION}${projectId}/cloud-hosting`;
    linkMsg = 'Subscribe';
  }
  console.log('disable :>> ', disable);
  if (disable) {
    return (
      <div
        className="gjs-mdl-container publish"
        style={{
          display: !popoverOpen ? 'none' : '',
        }}
      >
        <div className="gjs-mdl-dialog gjs-one-bg gjs-two-color">
          <div className="gjs-mdl-header">
            <div className="d-flex justify-content-between" style={{ width: '96%' }}>
              <div className="gjs-mdl-title">Publish your app for the end users.</div>
            </div>
            <div className="gjs-mdl-btn-close" onClick={toggle} data-close-modal="">
              ⨯
            </div>
          </div>
          <div className="gjs-mdl-content" style={{ textAlign: 'center' }}>
            {message}
            <br />
            <a href={link} className="btn btn-theme-submit btn-sm">
              <i className={'wb webconnect-paper-plane-fill'}></i> {linkMsg}
            </a>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="gjs-mdl-container publish"
        style={{
          display: !popoverOpen ? 'none' : '',
        }}
      >
        <div className="gjs-mdl-dialog gjs-one-bg gjs-two-color">
          <div className="gjs-mdl-header">
            <div className="d-flex justify-content-between" style={{ width: '96%' }}>
              <div className="gjs-mdl-title">Publish your app for the end users.</div>
              <a
                href={`${redirectUrl}app-setting/${projectId}/setting/codeExport?token=${token}`}
                className="btn btn-theme-submit btn-sm d-flex align-items-center"
                title="Code Export"
              >
                <i className={'wb webconnect-cursor-fill'}></i>&nbsp;Export Code
              </a>
            </div>
            <div className="gjs-mdl-btn-close" onClick={toggle} data-close-modal="">
              ⨯
            </div>
          </div>
          <div className="gjs-mdl-content">
            <div id="gjs-mdl-c">
              <div className="row pt-2 pb-2">
                <div className="col-md-12 col-sm-12">
                  <strong>Publish your app for the end users on specific environment.</strong>
                </div>
              </div>
            </div>
          </div>
          <div className="gjs-mdl-collector">
            <div className="pt-2 pb-2">
              <div className="col-md-12 col-sm-12">
                <table className="table table-stripped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th>Server</th>
                      <th>URL</th>
                      <th>Versions</th>
                      <th>Debug</th>
                      <th>Clean Publish</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {environments.map((env) => (
                      <tr key={env.uuid}>
                        <td>{voca.titleCase(env.envType)}</td>
                        <td>
                          <p>{generateProjectURL(env.envType, domainName, seoName, slug)}</p>
                          {env.envType === 'PRODUCTION' && urlToOpen && (
                            <p>
                              <i
                                className="wb webconnect-box-arrow-up-right"
                                title="Open link in new tab"
                              ></i>
                              <a
                                className="icon-link"
                                href={urlToOpen}
                                target="_blank"
                                title="Open link in new tab"
                              >
                                {voca.truncate(urlToOpen, 50)}
                              </a>
                            </p>
                          )}
                        </td>
                        <td>
                          <select
                            name="selVersion"
                            className="form-control"
                            value={selVersion[env.envType]}
                            onChange={(event) => handleVersionChange(event, env.envType)}
                          >
                            <option value="">Select Version</option>
                            {versions.map((version) => (
                              <option value={version.currentVersion} key={version.currentVersion}>
                                v{version.currentVersion}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <div className="custom-control custom-switch ml-3">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id={`debugModeToggle-${env.envType}`}
                              checked={
                                debugModeState[env.envType]
                                  ? debugModeState[env.envType].isEnable
                                  : false
                              }
                              onChange={() =>
                                isReadOnly ? null : handleDebugModeToggle(env.envType)
                              }
                              disabled={isReadOnly}
                              title={isReadOnly && 'Read-Only Mode'}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={`debugModeToggle-${env.envType}`}
                            ></label>
                          </div>
                        </td>
                        <td>
                          <div className="custom-control custom-switch ml-3">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id={`cleanPublishToggle-${env.envType}`}
                              checked={cleanPublishState[env.envType]}
                              onChange={() => (isReadOnly ? null : handleCleanToggle(env.envType))}
                              disabled={isReadOnly}
                              title={isReadOnly && 'Read-Only Mode'}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor={`cleanPublishToggle-${env.envType}`}
                            ></label>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex justify-content-center my-3">
                            <button
                              type="button"
                              className="btn btn-theme-submit btn-sm"
                              onClick={() => {
                                window.open(
                                  generateProjectURL(env.envType, domainName, seoName, slug, true),
                                );
                              }}
                            >
                              <i className="wb webconnect-eye-fill"></i>&nbsp;View
                            </button>
                            &nbsp;
                            <button
                              type="button"
                              className="btn btn-theme-submit btn-sm"
                              onClick={() =>
                                isReadOnly
                                  ? null
                                  : publishApp(
                                      env.envType,
                                      env.name,
                                      cleanPublishState[env.envType],
                                    )
                              }
                              disabled={isPublishing || isReadOnly}
                              title={isReadOnly && 'Read-Only Mode'}
                            >
                              <i className="wb webconnect-paper-plane-fill"></i>
                              &nbsp;Publish
                              <CustomLoader loading={isPublishing} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default PublishProjectModal;
